import React from 'react';
import type {Capture, Parser, ReactOutput, SingleASTNode, State} from 'simple-markdown';

const questionStemRegex = /^\[question-stem\]([\s\S]*?)\[\/question-stem\]/;

// renders [question-stem]...[/question-stem] as-is in a div
// for when we're not extracting to the right side
export const questionStemRule = {
  order: 0,
  match: (source: string) => questionStemRegex.exec(source),
  parse: (capture: Capture, parse: Parser, state: State) => ({
    // same workaround as in collapsibleArea.js
    // so block parser works as expected
    content: parse(`\n\n${capture[1].trim()}\n\n`, {
      ...state,
      // workaround to force block parser
      // so leading spaces before [question-stem] don't break headings
      inline: false
    })
  }),
  react: (node: SingleASTNode, output: ReactOutput) => {
    return <div>{output(node.content)}</div>;
  }
};
